/**
 *
 *
 * @class Oskari.nba.bundle.nba-registers.view.RegisterSearchTab
 */
Oskari.clazz.define('Oskari.nba.bundle.nba-registers.view.RegistersSearchTab',
/**
 *
 *
 */
function (instance) {
  this.instance = instance;
  this.sandbox = instance.getSandbox();
  this.loc = instance.getLocalization('tab');
  this.resultsGrid = null;
  this.resultsContainer = null;
  this.templates = {};
  for (var t in this._templates) {
    if (this._templates.hasOwnProperty(t)) {
      this.templates[t] = jQuery(this._templates[t]);
    }
  }
  this.progressSpinner = Oskari.clazz.create('Oskari.userinterface.component.ProgressSpinner');
  this.tabContent = this._initContent();
  // this.resultsContainer = this._initResultGrid();
  this._getRegisters();
  this._dialog = null;
}, {
  _templates: {
    tabContent: '<div class="nba-searchContainer">' + '<div class="nbaRegisterHeader"></div>' + '<div class="registerSelect"><select></select></div>' + '<div class="searchDescription"></div>' + '<div class="nba-searchInput"></div>' + '<div class="nba-searchButton"></div>' + '<div class="showAllResultsLink"></div>' + '<div class="nba-progressSpinner"></div>' + '</div>',
    resultsGrid: '<div class="resultsContainer">' + '<div class="resultsTitle"></div>' + '<div class="grid"></div>' + '<div>'
  },
  getTitle: function getTitle() {
    return this.loc.title;
  },
  getContent: function getContent() {
    return this.tabContent;
  },
  requestToAddTab: function requestToAddTab() {
    var requestBuilder = Oskari.requestBuilder('Search.AddTabRequest');
    var request;
    if (requestBuilder) {
      request = requestBuilder(this.getTitle(), this.getContent());
      this.sandbox.request(this.instance, request);
    }
  },
  _showMessage: function _showMessage(title, content, buttons, isModal) {
    var me = this;
    this.closeDialog();
    this._dialog = Oskari.clazz.create('Oskari.userinterface.component.Popup');
    if (typeof buttons === 'undefined') {
      var okBtn = Oskari.clazz.create('Oskari.userinterface.component.buttons.OkButton');
      okBtn.setHandler(function () {
        me._dialog.close(true);
        me._dialog = null;
      });
      buttons = [okBtn];
    }
    this._dialog.show(title, content, buttons);
    if (isModal) {
      this._dialog.makeModal();
    }
  },
  closeDialog: function closeDialog() {
    if (this._dialog) {
      this._dialog.close(true);
      this._dialog = null;
    }
  },
  _initContent: function _initContent() {
    var me = this;
    var tabContent = this.templates.tabContent.clone();
    var headerLabel = this.loc.header;
    var selectLabel = this.loc.selectRegister;
    // var checkboxLabel = this.loc.limitToArea;
    // var searchDesc = this.loc.searchDesc;
    var searchPlaceholder = this.loc.searchPlaceholder;
    var searchInput = Oskari.clazz.create('Oskari.userinterface.component.FormInput', 'nba-registers-search-input');
    var searchButton = Oskari.clazz.create('Oskari.userinterface.component.buttons.SearchButton');
    var showAllResultsLink = jQuery('<a href="#">' + this.loc.showAllResultsOnMap + '</a>');
    tabContent.find('div.nbaRegisterHeader').append(headerLabel);
    tabContent.find('div.registerSelect').prepend(selectLabel);
    // tabContent.find('div.limitResultsToArea').append(checkboxLabel);
    // tabContent.find('div.searchDescription').append(searchDesc);

    var doSearch = function doSearch() {
      var selectElement = me.getContent().find('div.registerSelect select');
      if (me.resultsContainer != null) {
        me.resultsContainer.empty();
      }
      tabContent.find('div.showAllResultsLink').hide();
      searchInput.setValidator(function (obj) {
        var errors = [];
        var val = obj.getValue();
        var name = obj.getName();
        if (val.length < 4) {
          errors.push({
            field: name,
            error: 'Minimum of four characters'
          }); // TODO make localization
        }
        return errors;
      });
      searchInput.setRequired(true, 'You should fill this input'); // TODO make localization

      searchInput.clearErrors();
      var errors = searchInput.validate();
      if (errors != null && errors.length > 0) {
        searchInput.showErrors(errors);
      } else {
        var params = {
          keyword: searchInput.getValue(),
          registries: selectElement.val(),
          geometry: ''
        };
        me._getRegistryItems(params);
      }
    };

    // add search input
    searchInput.setIds(null, 'nba-registers-search-input');
    searchInput.setPlaceholder(searchPlaceholder);
    searchInput.addClearButton();
    searchInput.bindEnterKey(doSearch);

    // add search button
    searchButton.setHandler(doSearch);
    tabContent.find('div.nba-searchInput').append(searchInput.getField());
    tabContent.find('div.nba-searchButton').append(searchButton.getElement());
    showAllResultsLink.bind('click', function () {
      me._showAllResultsOnMap();
      return false;
    });
    tabContent.find('div.showAllResultsLink').append(showAllResultsLink);
    tabContent.find('div.showAllResultsLink').hide();
    this.progressSpinner.insertTo(tabContent.find('div.nba-progressSpinner'));
    return tabContent;
  },
  _filterLayers: function _filterLayers(item, layers) {
    // classification is only used for Muinaisjaannosrekisteri
    if (item.rekisteri === 'Muinaisjaannosrekisteri') {
      return layers.filter(function (layer) {
        var _item$rekisterikohtai;
        return layer.classification === ((_item$rekisterikohtai = item.rekisterikohtainenLisatieto) === null || _item$rekisterikohtai === void 0 ? void 0 : _item$rekisterikohtai.laji);
      });
    }
    return layers;
  },
  _renderResultGrid: function _renderResultGrid(results) {
    var _this = this;
    var me = this;
    var resultGrid = this.templates.resultsGrid.clone();
    var gridTexts = this.loc.grid;
    var gridModel = Oskari.clazz.create('Oskari.userinterface.component.GridModel');
    var grid = Oskari.clazz.create('Oskari.userinterface.component.Grid');
    var searchInput = jQuery(me.tabContent.find('#nba-registers-search-input'));

    // set the title and number of given results
    resultGrid.find('div.resultsTitle').append(me.loc.searchResults + ': ' + results.length + ' ' + me.loc.forSearch + " '" + searchInput.val() + "'");
    gridModel.setIdField('id');
    if (Array.isArray(results)) {
      var registryLayers = Oskari.getSandbox().findRegisteredModuleInstance('nba-registers').conf.registryLayers;

      // look object registrylayers as key value
      var mapLayers = {};
      for (var key in registryLayers) {
        if (registryLayers.hasOwnProperty(key)) {
          if (!mapLayers[registryLayers[key].name]) {
            mapLayers[registryLayers[key].name] = [];
          }
          registryLayers[key].mapLayerID = key;
          mapLayers[registryLayers[key].name].push(registryLayers[key]);
        }
      }
      var registries = Oskari.getSandbox().findRegisteredModuleInstance('nba-registers').conf.registries;
      results.forEach(function (result) {
        var boundsReformat = [result.minX, result.minY, result.maxX, result.maxY];
        var markerCoordinates = [{
          coordinateY: (result.minY + result.maxY) / 2,
          coordinateX: (result.minX + result.maxX) / 2
        }];
        // TODO: slowish
        var registry = registries.filter(function (reg) {
          return reg.koodi === result.rekisteri;
        })[0];
        var item = {
          id: result.id,
          desc: result.nimi,
          mapLayers: _this._filterLayers(result, mapLayers[result.rekisteri]),
          bounds: boundsReformat,
          itemClassName: result.rekisteri,
          registryIdentifier: result.rekisteri,
          registry: registry.tekstiFin,
          municipality: result.kunta,
          markersCoordinates: markerCoordinates
        };
        gridModel.addData(item);
      });
    }
    grid.setDataModel(gridModel);
    grid.setVisibleFields(['id', 'desc', 'registry', 'municipality']);
    grid.setColumnValueRenderer('id', function (name, data) {
      if (typeof data === 'undefined') {
        return name;
      }
      var idColumnDiv = jQuery('<div ></div>');
      var idLink = jQuery('<a href="#">' + name + '</a>');
      idLink.bind('click', function () {
        // zoom to object and show GFI popup
        data.desc = 'aaa';
        me._zoomToObject(data, true);
        return false;
      });
      idColumnDiv.append(idLink);
      return idColumnDiv;
    });
    grid.setColumnUIName('id', gridTexts.id);
    grid.setColumnUIName('desc', gridTexts.desc);
    grid.setColumnUIName('registry', gridTexts.registry);
    grid.setColumnUIName('municipality', gridTexts.municipality);
    grid.renderTo(resultGrid.find('div.grid'));
    this.tabContent.append(resultGrid);
    this.resultsGrid = grid;
    return resultGrid;
  },
  _zoomToObject: function _zoomToObject(data, showGfi) {
    var me = this;

    // remove all markers
    var removeMarkersReqBuilder = Oskari.requestBuilder('MapModulePlugin.RemoveMarkersRequest');
    if (removeMarkersReqBuilder) {
      me.sandbox.request(me.instance, removeMarkersReqBuilder());
    }

    // showing all layers for the register
    if (data != null && data.mapLayers != null) {
      for (var i = 0; i < data.mapLayers.length; i++) {
        var mapLayerId = data.mapLayers[i].mapLayerID;
        var layer = me.sandbox.findMapLayerFromAllAvailable(mapLayerId);
        if (layer != null) {
          me.sandbox.postRequestByName('AddMapLayerRequest', [mapLayerId, true]);
        }
      }
    }
    if (data != null && data.bounds != null) {
      var extent = data.bounds;
      var lon = (extent[2] + extent[0]) / 2;
      var lat = (extent[3] + extent[1]) / 2;
      var lonlat = {
        lon: lon,
        lat: lat
      };

      // show new marker(s)

      var geoJson = {
        type: 'FeatureCollection',
        crs: {
          type: 'name',
          properties: {
            name: 'EPSG:3067'
          }
        },
        features: []
      };
      if (data.markersCoordinates) {
        for (var j = 0; j < data.markersCoordinates.length; j++) {
          lon = data.markersCoordinates[j].coordinateX;
          lat = data.markersCoordinates[j].coordinateY;
          var marker = {
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: [lon, lat]
            }
          };
          geoJson.features.push(marker);
        }
      } else {
        var _marker = {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [lon, lat]
          }
        };
        geoJson.features.push(_marker);
      }
      ;
      var rn = 'MapModulePlugin.AddFeaturesToMapRequest';
      var options = {
        layerId: 'MARKER_LAYER',
        clearPrevious: true,
        centerTo: true,
        featureStyle: {
          image: {
            shape: 4,
            size: 5
          }
        }
      };
      me.sandbox.postRequestByName(rn, [geoJson, options]);
      // show GFI popup

      if (showGfi) {
        var popupData = me._getGfiPopupData(data);
        var registryData = {
          via: 'registry',
          features: [popupData],
          lonlat: lonlat
        };
        this._handleNbaInfoResult(registryData);
        var infoEvent = Oskari.eventBuilder('GetInfoResultEvent')(registryData);
        me.sandbox.notifyAll(infoEvent);
      }
    } else {
      me._showMessage(me.loc.noticeTitle, me.loc.searchResultNoGeometry);
      if (data != null && showGfi) {
        var _popupData = me._getGfiPopupData(data);
        var _registryData = {
          via: 'registry',
          features: [_popupData],
          lonlat: Oskari.getSandbox().findRegisteredModuleInstance('MainMapModule').getMapCenter()
        };
        // this._handleNbaInfoResult(registryData);
        var _infoEvent = Oskari.eventBuilder('GetInfoResultEvent')(_registryData);
        me.sandbox.notifyAll(_infoEvent);
      }
    }
  },
  /**
  * Formats the given data and sends a request to show infobox.
  *
  * @method _handleInfoResult
  * @private
  * @param  {Object} data
  */
  _handleNbaInfoResult: function _handleNbaInfoResult(data) {
    var me = this;
    var content = [];
    var contentData = {};
    var fragments = [];
    var actions = {};
    var loc = Oskari.getLocalization('nba-registers').gfiPopup;
    var wideHeader = false;
    if (data.via === 'registry') {
      fragments = this.formatters.registry(data, this);
      wideHeader = true;
      if (data.features != null && fragments.length) {
        var _loop = function _loop() {
          // if user has permissions add edit action for the registry item
          // const registryEditRoles = editorRoles[data.features[i].registryIdentifier] != null ? editorRoles[data.features[i].registryIdentifier] : editorRoles.general;
          // if (this._hasUserPermissions(registryEditRoles) && data.features[i].editable === true) {
          var itemData = {
            id: data.features[i].id,
            registryIdentifier: data.features[i].registryIdentifier,
            mapLayers: data.features[i].mapLayers
          };
          actions = [];
          actions.push({
            name: loc.editItem + ' ' + itemData.id,
            type: 'link',
            action: function action() {
              // showing all layers for the register
              if (itemData != null && itemData.mapLayers != null) {
                for (var j = 0; j < itemData.mapLayers.length; j++) {
                  var mapLayerId = itemData.mapLayers[j].mapLayerID;
                  var layer = Oskari.getSandbox().findMapLayerFromAllAvailable(mapLayerId);
                  if (layer != null) {
                    Oskari.getSandbox().postRequestByName('AddMapLayerRequest', [mapLayerId, true]);
                  }
                }
              }
              // open registry editor
              // Oskari.getSandbox().postRequestByName('RegistryEditor.ShowRegistryEditorRequest', [itemData]);
              // close Search bundle after moving to registry editor
              // Oskari.getSandbox().postRequestByName('userinterface.UpdateExtensionRequest', [undefined, 'close', 'Search']);
              me._closeGfiInfo();
            }
          });
          // }
        };
        for (var i = 0; i < data.features.length; i++) {
          _loop();
        }
      }
    } else {
      fragments = this._formatWFSFeaturesForInfoBox(data);
    }
    if (fragments.length) {
      contentData.actions = actions;
      contentData.html = this._renderFragments(fragments, wideHeader);
      contentData.layerId = fragments[0].layerId;
      content.push(contentData);
    }
  },
  /**
  * Closes the infobox with GFI data
  *
  * @method _closeGfiInfo
  * @private
  */
  _closeGfiInfo: function _closeGfiInfo() {
    var reqBuilder = Oskari.requestBuilder('InfoBox.HideInfoBoxRequest');
    var request;
    if (reqBuilder) {
      request = reqBuilder(this.infoboxId);
      Oskari.getSandbox().request(this, request);
    }
  },
  /**
  * @method _hasUserPermissions
  * Checks if any of the user's roles is contained in allowedRoles array
  *
  * @param {Array} allowedRoles array of role names
  *
  */
  _hasUserPermissions: function _hasUserPermissions(allowedRoles) {
    var me = this;
    var userRoles = me.sandbox.getUser().getRoles();
    var hasPermissions = false;
    if (me.sandbox.getUser().isLoggedIn()) {
      var _loop2 = function _loop2(i) {
        if (allowedRoles.some(function (allowedRole) {
          return allowedRole === userRoles[i].name;
        })) {
          hasPermissions = true;
          return 1; // break
        }
      };
      for (var i = 0; i < userRoles.length; i++) {
        if (_loop2(i)) break;
      }
    }
    return hasPermissions;
  },
  /**
  * Shows given content in given location using infobox bundle
  *
  * @method _showNbaGfiInfo
  * @private
  * @param {Object[]} content infobox content array
  * @param {data} data.lonlat location for the GFI data
  * @param {formatters} formatter functions
  * @param {params} params for request
  */
  _showNbaGfiInfo: function _showNbaGfiInfo(content, data, formatters, params) {
    var reqBuilder = Oskari.requestBuilder('InfoBox.ShowInfoBoxRequest');
    var request;
    var options = {
      hidePrevious: params.hidePrevious === undefined ? true : params.hidePrevious,
      colourScheme: params.colourScheme,
      font: params.font
    };
    if (reqBuilder) {
      request = reqBuilder(params.infoboxId, params.title, content, data.lonlat, options);
      Oskari.getSandbox().request('nba-registers', request);
    }
  },
  /**
  * @method _getRegisters
  * Get register names from config of the bundle
  */
  _getRegisters: function _getRegisters() {
    var me = this;
    var conf = me.instance.conf;
    var registries = [];
    var lang = Oskari.getLang();
    var selectElement = this.getContent().find('div.registerSelect select');
    var registryName;
    var i;
    if (conf != null) {
      registries = conf.registries;
      // sort registries based on predefined order
      var order = ['Muinaisjaannosrekisteri', 'Hankerekisteri', 'Muinaisjaannostenhoitorekisteri', 'Rakennusperintorekisteri', 'VARK', 'RKY2000', 'RKY', 'Maailmanperintokohteet'];
      registries.sort(function (a, b) {
        var indexA = order.indexOf(a.koodi);
        var indexB = order.indexOf(b.koodi);
        if (indexA === indexB) {
          return 0;
        }
        return indexA < indexB ? -1 : 1;
      });

      // add 'all' element
      var allOptionElement = document.createElement('option');
      allOptionElement.setAttribute('value', '');
      var text = document.createTextNode(me.loc.all);
      allOptionElement.appendChild(text);
      selectElement.append(allOptionElement);
      for (i in registries) {
        // if (registries[i][lang] != null) {
        //    registryName = registries[i][lang].name;
        // } else {
        //    registryName = i;
        // }
        registryName = registries[i].tekstiFin;
        var optionElement = document.createElement('option');
        optionElement.setAttribute('value', registries[i].koodi);
        var _text = document.createTextNode(registryName);
        optionElement.appendChild(_text);
        selectElement.append(optionElement);
      }
    }
  },
  _getRegistryItems: function _getRegistryItems(params) {
    var me = this;
    this.progressSpinner.start();
    this.instance.getSearchService().getRegistryItems(params, function (results) {
      me._handleRegistryItemsResults(results);
    }, function (jqXHR, textStatus, errorThrown) {
      me.progressSpinner.stop();
      if (textStatus == 'Gateway Time-out') {
        me._showMessage(me.loc.errorTitle, me.loc.searchErrorTimeout);
      } else {
        me._showMessage(me.loc.errorTitle, me.loc.searchErrorGeneral);
      }
    });
  },
  _handleRegistryItemsResults: function _handleRegistryItemsResults(results) {
    this.progressSpinner.stop();
    if (jQuery.isEmptyObject(results)) {
      this.tabContent.find('div.showAllResultsLink').hide();
    } else {
      this.tabContent.find('div.showAllResultsLink').show();
    }
    this.resultsContainer = this._renderResultGrid(results);
  },
  _showAllResultsOnMap: function _showAllResultsOnMap() {
    var me = this;
    var geoJson = {
      type: 'FeatureCollection',
      crs: {
        type: 'name',
        properties: {
          name: 'EPSG:3067'
        }
      },
      features: []
    };
    // 1. get result items
    if (me.resultsGrid != null) {
      var items = me.resultsGrid.getDataModel().getData();
      for (var i = 0; i < items.length; i++) {
        var lon = null;
        var lat = null;
        var data = items[i];
        if (data.markersCoordinates) {
          for (var j = 0; j < data.markersCoordinates.length; j++) {
            lon = data.markersCoordinates[j].coordinateX;
            lat = data.markersCoordinates[j].coordinateY;
            var marker = {
              type: 'Feature',
              geometry: {
                type: 'Point',
                coordinates: [lon, lat]
              }
            };
            geoJson.features.push(marker);
          }
        } else if (data.bounds) {
          var extent = data.bounds;
          lon = (extent[2] + extent[0]) / 2;
          lat = (extent[3] + extent[1]) / 2;
          var _marker2 = {
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: [lon, lat]
            }
          };
          geoJson.features.push(_marker2);
        }
        ;
      }
      var rn = 'MapModulePlugin.AddFeaturesToMapRequest';
      var options = {
        layerId: 'MARKER_LAYER',
        clearPrevious: true,
        centerTo: true,
        featureStyle: {
          image: {
            shape: 4,
            size: 5
          }
        }
      };
      Oskari.getSandbox().postRequestByName(rn, [geoJson, options]);
    }
  },
  /**
  * @method _getGfiPopupData
  * Filters grid model data passed to the popup
  *
  * @param {Object} data grid model data
  *
  */
  _getGfiPopupData: function _getGfiPopupData(data) {
    return {
      id: data.id,
      desc: data.desc,
      nbaEditUrl: data.nbaEditUrl,
      nbaViewUrl: data.nbaViewUrl,
      mapLayers: data.mapLayers,
      bounds: data.bounds,
      itemClassName: data.itemClassName,
      registryIdentifier: data.registryIdentifier,
      registry: data.registry,
      municipality: data.municipality,
      editable: data.editable
    };
  }
});